const indexItems = [
  { title: '悬疑剧大全', desc: '高分国产悬疑 + 经典推理剧', icon: 'ri-search-eye-line', count: '120+' },
  { title: '古装仙侠馆', desc: '玄幻修仙 · 古装甜宠 · 武侠传奇', icon: 'ri-sword-line', count: '200+' },
  { title: '都市情感站', desc: '职场奋斗 · 甜蜜恋爱 · 家庭温情', icon: 'ri-heart-pulse-line', count: '150+' },
  { title: '韩剧放映厅', desc: '复仇爽剧 · 浪漫爱情 · 治愈日常', icon: 'ri-clapperboard-line', count: '180+' },
  { title: '美剧精选集', desc: 'HBO大作 · Netflix精选 · 经典老剧', icon: 'ri-global-line', count: '160+' },
  { title: '动漫追番表', desc: '热血战斗 · 治愈日常 · 奇幻冒险', icon: 'ri-rocket-2-line', count: '300+' },
  { title: '经典重温区', desc: '那些年错过的口碑好剧都在这里', icon: 'ri-time-line', count: '250+' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
          题材索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          按题材类型快速定位，一站浏览全部精彩内容
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexItems.map((item, idx) => (
            <div
              key={idx}
              className={`group bg-background-50 border border-background-200 rounded-xl p-5 text-center transition-all duration-300 hover:border-primary-200 hover:shadow-sm cursor-pointer ${
                indexItems.length === 7 && idx === 6 ? 'col-span-2 sm:col-span-3 lg:col-span-1 lg:col-start-2' : ''
              }`}
            >
              <span className="w-10 h-10 flex items-center justify-center bg-accent-100 text-accent-500 rounded-xl mx-auto mb-3 text-lg group-hover:bg-accent-200 transition-colors">
                <i className={item.icon}></i>
              </span>
              <h3 className="text-sm font-bold text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-2 line-clamp-1">{item.desc}</p>
              <span className="text-xs text-primary-500 font-medium">{item.count}部剧集</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}